/**
 * Map a browser route (pathname + search) to a route-map node id
 * (schema §J / backend orchestrator/route_map.py).
 *
 * The mirror of the backend NAVIGATION_TARGETS (which maps node id -> path);
 * here we resolve the other direction so a MANUAL navigation the doctor
 * performs can be reported to the copilot with the node it landed on. Kept
 * pure + standalone so it's unit-testable and reusable.
 *
 * Order matters: the more specific /settings/* nodes are checked before the
 * generic /settings, and /patients/visits (the recording screen) before the
 * patient list.
 */

export function resolveNodeId(pathname, search = "") {
  const p = String(pathname || "");
  const s = String(search || "");

  if (p.startsWith("/patients/visits")) return "recording_screen";
  if (p === "/patients" || p.startsWith("/patients/list")) return "patient_list";
  if (p.startsWith("/home/dashboard")) return "dashboard";
  if (p.startsWith("/insights")) return "insights";
  if (p.startsWith("/scheduling")) return "scheduling";
  if (p.startsWith("/customForms")) return "custom_forms";
  if (p.startsWith("/store")) return "store";
  if (p.startsWith("/settings/archived_encounters")) return "archived_encounters";
  if (p.startsWith("/settings/profile")) {
    return s.includes("isEdit=true") ? "profile_edit" : "profile";
  }
  if (p.startsWith("/settings")) return "settings";
  return null; // unknown / unmapped route
}

/**
 * Decide whether a route change should be reported as a MANUAL navigation.
 * Pure so the panel effect's logic is unit-testable.
 *
 *   - no real node change            -> false
 *   - unmapped route (node null)     -> false (nothing to narrate)
 *   - within the agent-suppression   -> false (the agent caused this nav and
 *     window                            already reported it — don't duplicate)
 *   - otherwise                      -> true (the doctor navigated themselves)
 *
 * First-mount seeding (don't emit for the initial route) is handled by the
 * caller via a sentinel; this function assumes a real prior node.
 */
export function shouldEmitManualNav(node, prevNode, sinceAgentMs, suppressMs) {
  if (node === prevNode) return false;
  if (node === null) return false;
  if (sinceAgentMs < suppressMs) return false;
  return true;
}
